import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {ConfigService} from '../../shared/services/config.service';
import {TranslatePipe} from '../../shared/pipes/translate.pipe';
import {SegmentHandler} from '../../shared/libraries/segment-handler';
import {AnalyticsHandler} from '../../shared/libraries/analytics-handler';
import {Constants} from '../../shared/constants';

@Component({
    selector: 'app-availability-selector',
    templateUrl: './availability-selector.component.html',
    styleUrls: ['./availability-selector.component.scss'],
    providers: [TranslatePipe]
})
export class AvailabilitySelectorComponent implements OnInit {
    /**
     * Header title
     * @var {string}
     */
    public title = '';

    /**
     * Header disclaimer
     * @var {string}
     */
    public disclaimer = '';

    /**
     * Selectable segments
     * @var {Array<object>}
     */
    public segments: Array<object> = [];

    /**
     * Current selected segment
     */
    public selectedSegment = '';

    /**
     * Application configuration
     * @var {any}
     */
    private _config: any = {};

    /**
     * Flag to check if page load analytics event was fired
     * @var {boolean}
     */
    private _pageLoadAnalyticsTriggered = false;

    /**
     * Class constructor
     *
     * @param _apiService
     * @param _configService
     * @param _translatePipe
     * @param _segmentHandler
     * @param _analyticsHandler
     */
    constructor(
        private _apiService: ApiService,
        private _configService: ConfigService,
        private _translatePipe: TranslatePipe,
        private _segmentHandler: SegmentHandler,
        private _analyticsHandler: AnalyticsHandler
    ) {
        this._config = this._configService.getConfig();
        this._segmentHandler = this._segmentHandler.initialize(this._config.segments, this._config.segmentBlacklist, this._config.defaultSegment);
    }

    /**
     * On init method
     */
    ngOnInit() {
        this.title = 'header.title';
        this.disclaimer = 'header.disclaimer';

        this._getSegmentsInfo();
    }

    /**
     * Get selectable segments information
     *
     * @private
     * @returns {void}
     */
    private _getSegmentsInfo() {
        const segments = this._segmentHandler.getSegments();

        for (const segment of segments) {
            const translationKey = `experience.${segment}`;
            const text = this._translatePipe.transform(translationKey);

            // If the text is empty, null or not translated, skip it.
            if (!text?.includes(translationKey) && text) {
                this.segments.push({
                    'segmentId': segment,
                    'text': text
                });
            }

        }

        this.selectedSegment = this._segmentHandler.getSelectedSegment();
    }

    /**
     * Get the selected segment availability
     *
     * @param event Polymer event
     * @private
     * @returns {void}
     */
    public setSelectedSegment(event) {
        this._apiService.setSelectedSegment(event.detail.value);

        if (this._pageLoadAnalyticsTriggered) {
            this._analyticsHandler
                .setLinkId(Constants.ANALYTICS_LINK_ID_TIER_TOGGLE)
                .setSelectedSegment(event.detail.value)
                .trackAnalytics(Constants.ANALYTICS_EVENT_TYPE_SEGMENT_CHANGED);
        }

        this._apiService.selectedSegment.subscribe(() => {
            if (!this._pageLoadAnalyticsTriggered) {
                this._pageLoadAnalyticsTriggered = true;
            }
        });
    }
}
